import Authorization from 'components/MissedPayments/Authorization/Authorization';
import MakeAPayment from 'components/MissedPayments/MakeAPayment/MakeAPayment';
import MakingPayment from 'components/MissedPayments/MakingPayment/MakingPayment';
import MissedPayment from 'components/MissedPayments/MissedPayment/MissedPayment';
import MissedPaymentReason from 'components/MissedPayments/MissedPaymentReason/MissedPaymentReason';
import PaymentFailed from 'components/MissedPayments/PaymentFailed/PaymentFailed';
import PaymentInitiated from 'components/MissedPayments/PaymentInitiated/PaymentInitiated';
import WaitingAuthorization from 'components/MissedPayments/WaitingAuthorization/WaitingAuthorization';
import BankAccount from 'components/Verification/Steps/CheckingAccount/BankAccount';
import SelectAccount from 'components/Verification/Steps/CheckingAccount/SelectAccount';
import Plaid from 'components/Verification/Steps/CheckingAccount/Plaid';
import {
  CheckingAccountResult,
  MakeAPaymentResult,
  MakingPaymentResult,
  MissedPaymentResult,
} from 'enums/FlowNextResults';
import { RoutePath } from 'enums/Routes';

import { RouterType } from './types';

export const getMissedPaymentRoutes = (): RouterType => ({
  [RoutePath.MissedPayment]: {
    navigationInfo: { showBackLink: false, title: 'Missed Payment' },
    component: MissedPayment,
    handleNext: ({ navigate }) => (result) => {
      switch (result) {
        case MissedPaymentResult.CollectReason:
          navigate(RoutePath.MissedPaymentReason);
          break;
        case MissedPaymentResult.Error:
          navigate(RoutePath.Error);
          break;
        default:
          navigate(RoutePath.MakeAPayment);
          break;
      }
    },
  },
  [RoutePath.MissedPaymentReason]: {
    navigationInfo: { showBackLink: true, title: 'Missed Payment' },
    component: MissedPaymentReason,
    handleNext: ({ navigate }) => () => {
      navigate(RoutePath.MakeAPayment);
    },
  },
  [RoutePath.MakeAPayment]: {
    navigationInfo: { showBackLink: true, title: 'Missed Payment' },
    component: MakeAPayment,
    handleNext: ({ navigate }) => (result) => {
      switch (result) {
        case MakeAPaymentResult.Authorization:
          navigate(RoutePath.Authorization);
          break;
        case MakeAPaymentResult.MakePayment:
          navigate(RoutePath.MakingPayment);
          break;
        default:
          navigate(RoutePath.Plaid);
          break;
      }
    },
  },
  [RoutePath.Plaid]: {
    navigationInfo: { showBackLink: true, title: 'Missed Payment' },
    component: Plaid,
    handleNext: ({ navigate }) => (result) => {
      switch (result) {
        case CheckingAccountResult.MakePayment:
          navigate(RoutePath.MakingPayment);
          break;
        case CheckingAccountResult.Continue:
          navigate(RoutePath.Authorization);
          break;
        default:
          navigate(RoutePath.Error);
      }
    },
  },
  [RoutePath.BankAccount]: {
    navigationInfo: { showBackLink: true, title: 'Bank Account' },
    component: BankAccount,
    handleNext: ({ navigate }) => () => {
      navigate(RoutePath.Authorization);
    },
  },
  [RoutePath.PlaidCheckingAccounts]: {
    navigationInfo: { showBackLink: true, title: 'Bank Account' },
    component: SelectAccount,
    handleNext: ({ navigate }) => () => {
      navigate(RoutePath.Authorization);
    },
  },
  [RoutePath.Authorization]: {
    navigationInfo: { showBackLink: false, title: 'Authorization' },
    component: Authorization,
    handleNext: ({ navigate }) => () => {
      navigate(RoutePath.MakingPayment);
    },
  },
  [RoutePath.WaitingAuthorization]: {
    navigationInfo: { showBackLink: false },
    component: WaitingAuthorization,
    handleNext: ({ navigate }) => () => {
      navigate(RoutePath.MakingPayment);
    },
  },
  [RoutePath.MakingPayment]: {
    navigationInfo: { showBackLink: false },
    component: MakingPayment,
    handleNext: ({ navigate }) => (result) => {
      switch (result) {
        case MakingPaymentResult.Success:
          navigate(RoutePath.PaymentInitiated);
          break;
        case MakingPaymentResult.Failure:
          navigate(RoutePath.PaymentFailed);
          break;
        default:
          navigate(RoutePath.Error);
          break;
      }
    },
  },
  [RoutePath.PaymentInitiated]: {
    navigationInfo: { showBackLink: false, title: 'Payment Initiated' },
    component: PaymentInitiated,
    handleNext: ({ navigate }) => () => {
      navigate(RoutePath.FinancialDashboard);
    },
  },
  [RoutePath.PaymentFailed]: {
    navigationInfo: { showBackLink: false, title: 'Payment Error' },
    component: PaymentFailed,
  },
});
